import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import LoadingScreen from './components/loaders/loading';
import AuthGuard from './components/Guards/AuthGuard';
import GuestGuard from './components/Guards/GuestGuard';

import AuthLayout from 'src/Layouts/AuthLayout';
import DashboardLayout from 'src/Layouts/DashboardLayout';

export const renderRoutes = (routes = []) => (
    <Suspense fallback={<LoadingScreen />}>
        <Switch>
            {routes.map((route, i) => {
                const Guard = route.guard || Fragment;
                const Layout = route.layout || Fragment;
                const Component = route.component;

                return (
                    <Route
                        key={i}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => (
                            <Guard>
                                <Layout>
                                    {route.routes ? (
                                        renderRoutes(route.routes)
                                    ) : (
                                        <Component {...props} />
                                    )}
                                </Layout>
                            </Guard>
                        )}
                    />
                );
            })}
        </Switch>
    </Suspense>
);

const routes = [
    {
        exact: true,
        path: '/404',
        component: lazy(() => import('src/views/errors/NotFoundView')),
    },
    {
        exact: true,
        guard: GuestGuard,
        layout: AuthLayout,
        path: '/login',
        component: lazy(() => import('src/views/Auth/Login/login')),
    },
    {
        exact: true,
        guard: GuestGuard,
        layout: AuthLayout,
        path: '/register',
        component: lazy(() => import('src/views/Auth/Signup/signup')),
    },
    {
        exact: true,
        guard: GuestGuard,
        layout: AuthLayout,
        path: '/verify/:token',
        component: lazy(() => import('src/views/Auth/Verify/verify')),
    },
    {
        exact: true,
        guard: GuestGuard,
        layout: AuthLayout,
        path: '/reset/:token',
        component: lazy(() =>
            import('src/views/Auth/ResetPassword/resetPassword')
        ),
    },
    {
        exact: true,
        guard: GuestGuard,
        layout: AuthLayout,
        path: '/forgot-password',
        component: lazy(() =>
            import('src/views/Auth/ForgetPassword/forgetpass')
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/',
        component: lazy(() => import('src/views/Dashboard/Home/home')),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/group-overview',
        component: lazy(() =>
            import('src/views/Dashboard/GroupOverview/groupOverview')
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/offline-impact-assessment',
        component: lazy(() =>
            import(
                'src/views/Dashboard/OfflineImpactAssesment/offilineImpact'
            )
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/result-first-survey/:code',
        component: lazy(() =>
            import('src/views/Dashboard/Home/ResultFirstSurvey/resultFirst')
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/result-second-survey/:code',
        component: lazy(() =>
            import('src/views/Dashboard/Home/ResultSecondSurvey/resultSecond')
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/detailed-first-survey/:code',
        component: lazy(() =>
            import('src/views/Dashboard/Home/DetailFirstSurvey/detailsFirst')
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/detailed-second-survey/:code',
        component: lazy(() =>
            import(
                'src/views/Dashboard/Home/DetailSecondSurvey/detailsSecond'
            )
        ),
    },
    {
        exact: true,
        guard: AuthGuard,
        layout: DashboardLayout,
        path: '/comparison-first-and-final/:code',
        component: lazy(() => import('src/views/Dashboard/Home/ComparisonFirstandFinal/comparisonFirst'))
    },

    {
        path: '*',
        routes: [
            {
                component: () => <Redirect to="/404" />,
            },
        ],
    },
];
export default routes;
